import { useEffect } from "react";

export default function GlobalShortcuts() {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "F1") {
        e.preventDefault();
        e.stopImmediatePropagation();

        const search = document.getElementById("global-search");
        if (search) {
          search.focus();
          search.select();
        }
        return;
      }
      if (e.ctrlKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        document.getElementById("saveButton")?.click();
        return;
      }

      if (e.key === "Escape") {
        const search = document.getElementById("global-search");
        if (search) search.value = "";
        return;
      }

      // if (e.key === "Tab") {
      //   const active = document.activeElement;

      //   // If focus is currently inside any AG Grid → block and redirect
      //   if (active && active.closest(".ag-root-wrapper")) {
      //     e.preventDefault();   // stop tab from going into filter or cells

      //     // Move focus back to global search (or next button)
      //     const search = document.getElementById("global-search");
      //     if (search) {
      //       search.focus();
      //       return;
      //     }
      //   }
      // }
      if (e.key === "Tab") {
  const active = document.activeElement;

  // If inside AG Grid → SKIP it
  if (active && active.closest(".ag-root-wrapper")) {
    e.preventDefault();

    // Move to next natural focusable element (not search)
    const focusables = Array.from(
      document.querySelectorAll("a, button, input, select, textarea, [tabindex]:not([tabindex='-1'])")
    ).filter(el => !el.closest(".ag-root-wrapper"));

    const currentIndex = focusables.indexOf(active);
    const next = focusables[currentIndex + 1];

    if (next) next.focus();
    return;
  }
}
};


    window.addEventListener("keydown", handler, { capture: true });
    return () => window.removeEventListener("keydown", handler, { capture: true });

  }, []);

  return null;
}
